import * as z from "zod";

/** Approves a team access request for the current store; returns its one-time code. */
export const approveTeamAccess = {
  name: "approveTeamAccess" as const,
  input: z.object({
    clientId: z.string(),
    redirectUri: z.string(),
    scope: z.string().optional(),
    /** The store the consent page showed; refused if the signed-in store changed. */
    storeId: z.string(),
    /** PKCE S256 challenge: base64url SHA-256 of the app's verifier. */
    codeChallenge: z.string().regex(/^[A-Za-z0-9_-]{43}$/),
  }),
  output: z.object({ code: z.string() }),
};
